import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, ArrowRight, X } from 'lucide-react';
import { SEASONAL_PROMOS, SHOP_URL } from '../mock';

const CURRENT_PROMOS = (() => {
  const m = new Date().getMonth();
  const inSeason = SEASONAL_PROMOS.filter((p) => p.months.includes(m));
  return inSeason.length ? inSeason : [{ theme: 'Same-Day', title: 'Same-Day Flower Delivery', subtitle: 'Order before 2 PM \u2014 fresh bouquets delivered today', bg: '#3D5142', accent: '#DCE7DA', slug: null }];
})();

export default function SeasonalBanner() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % CURRENT_PROMOS.length), 4500);
    return () => clearInterval(t);
  }, []);

  if (!visible) return null;
  const promo = CURRENT_PROMOS[index];

  const handleClick = () => {
    if (promo.link) navigate(promo.link);
    else if (promo.slug) navigate(`/occasions/${promo.slug}`);
    else window.open(SHOP_URL, '_blank', 'noopener');
  };

  return (
    <div className="relative overflow-hidden transition-colors duration-700" style={{ backgroundColor: promo.bg }}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex items-center justify-center gap-3 py-2.5 text-center">
          <Sparkles className="w-4 h-4 shrink-0" style={{ color: promo.accent }} />
          <div key={index} className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 animate-[fadeIn_0.6s_ease]">
            <span className="text-[13.5px] font-semibold text-white tracking-wide">{promo.title}</span>
            <span className="hidden sm:inline text-[13px]" style={{ color: promo.accent }}>— {promo.subtitle}</span>
          </div>
          <button
            onClick={handleClick}
            className="group ml-1 inline-flex items-center gap-1 text-[13px] font-medium text-white underline underline-offset-4 decoration-white/40 hover:decoration-white transition-all whitespace-nowrap"
          >
            {promo.cta || 'Shop now'} <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
          </button>
        </div>
      </div>

      {/* progress dots */}
      <div className="absolute left-1/2 -translate-x-1/2 bottom-1 flex gap-1">
        {CURRENT_PROMOS.map((_, i) => (
          <span key={i} className="h-1 rounded-full transition-all duration-500" style={{ width: i === index ? 14 : 5, backgroundColor: i === index ? '#ffffff' : 'rgba(255,255,255,0.4)' }} />
        ))}
      </div>

      <button onClick={() => setVisible(false)} aria-label="Dismiss" className="absolute right-3 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition-colors">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
